import { RELATIONSHIPS } from 'pages/Complaint/ConsentForm/enum';
import { textAreaRegex, validateTextSchema, ErrorMessage } from 'utils/commonSchema';
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    oneOf: '',
    required: '',
  },
});

/* eslint-disable no-useless-escape */
const emailRegex =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
const phoneNumberRegex =
  /^(([0-9]{6,20})|([\+]?[(]?(([2-9][0-9])|([2-8][0-9][0-9]))[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}))$/;
const textFieldMax = 50;
const textFieldMin = 4;
const textMin = 1;
const orgMax = 100;

const validationSchema = yup.object().shape({
  policyOrClaim: yup.string().oneOf(['claim']).required(),

  claimNumber: yup
    .string()
    .nullable()
    .when('policyOrClaim', {
      is: 'claim',
      then: () =>
        yup
          .string()
          .matches(textAreaRegex, ErrorMessage.ALPHA_NUMERIC)
          .min(textFieldMin, ErrorMessage.MIN_4_CHARACTER_MORE)
          .max(textFieldMax)
          .required(ErrorMessage.MIN_4_CHARACTER_MORE),
    }),

  relationship: yup.string().oneOf(RELATIONSHIPS).required('Relationship is required'),

  firstName: validateTextSchema({ minLen: textMin, maxLen: textFieldMax, required: true }),

  lastName: validateTextSchema({ minLen: textMin, maxLen: textFieldMax, required: true }),

  organisation: validateTextSchema({ minLen: textMin, maxLen: orgMax, required: true }),

  emailAddress: yup
    .string()
    .matches(emailRegex, 'Please enter a valid email address')
    .max(orgMax)
    .required('Please enter a valid email address'),

  phoneNumber: yup
    .string()
    .matches(phoneNumberRegex, 'Please enter a valid phone number')
    .min(textFieldMin)
    .max(20)
    .required('Please enter a valid phone number'),
});

export default validationSchema;
